import { CdxComment, CdxReply } from './cdx-comment';

export class CurrentCommentContainer {
  currentComment: CdxComment;
  currentReply: CdxReply;
  inError: boolean;

  constructor(currentComment: CdxComment, currentReply: CdxReply, inError: boolean) {
    this.currentComment = currentComment;
    this.currentReply = currentReply;
    this.inError = inError;
  }
}
